import { constant } from '@medflex/commons';
import React from 'react';
import PropTypes from 'prop-types';
import SearchHighlight from '../SearchHighlight';

const Role = ({ contact, searchTerm }) => {
  const {
    user: { workArea, areaOfActivity, jobTitle },
  } = contact;

  const role =
    workArea ||
    (areaOfActivity &&
      constant.areaOfActivity[areaOfActivity] !== constant.areaOfActivity.CUSTOM &&
      constant.areaOfActivity[areaOfActivity]) ||
    jobTitle;

  return searchTerm && role ? <SearchHighlight text={role} toHighlight={searchTerm} /> : role;
};

Role.defaultProps = {
  searchTerm: '',
};

Role.propTypes = {
  contact: PropTypes.shape({
    user: PropTypes.shape({
      workArea: PropTypes.string,
      areaOfActivity: PropTypes.string,
      jobTitle: PropTypes.string,
    }).isRequired,
  }).isRequired,
  searchTerm: PropTypes.string,
};

export default Role;
